import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

type Props = {
  serviced: number;
  notServiced: number;
};

const PieChart = ({ serviced, notServiced }: Props) => {
  const data = {
    labels: ['Serviced', 'Not serviced'],
    datasets: [
      {
        data: [serviced, notServiced],
        backgroundColor: ['#1f4e79', '#d1d1d1'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  };

  return (
    <div style={{ height: '250px', width: '250px' }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
